<template>
<el-header height="60px" class="header">
    <!-- Logo -->
    <div class="logo">
        <img src="../assets/logo.png" alt="">
    </div>
    
    <!-- Menu Principal -->
    <el-menu
        class="menu"
        mode="horizontal"
        background-color="#fff"
        text-color="#333"
        active-text-color="#409EFF"
        :default-active="currentRoute"
    >
        <el-menu-item index="/" @click="navigateTo('/')">
            <el-icon><House /></el-icon>
            <span>Home</span>
        </el-menu-item>
        <el-menu-item index="/tasks" @click="navigateTo('/tasks')">
            <el-icon><Check /></el-icon>
            <span>Tarefas</span>
        </el-menu-item>
        <el-menu-item index="/clients" @click="navigateTo('/clients')">
            <el-icon><Folder /></el-icon>
            <span>Clientes</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/users" @click="navigateTo('/users')">
            <el-icon><User /></el-icon>
            <span>Usuários</span>
        </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/reports/work-time" @click="navigateTo('/reports/work-time')">
          <el-icon><Histogram /></el-icon>
          <span>Relatórios</span>
      </el-menu-item>
        <el-menu-item v-if="isAdmin" index="/settings" @click="navigateTo('/settings')">
            <el-icon><Setting /></el-icon>
            <span>Configurações</span>
        </el-menu-item>
    </el-menu>
    
    <!-- Ações do Usuário -->
    <div class="user-actions">
        <el-button type="success" @click="handleCreateTask()" icon="Plus">
          Tarefa
        </el-button>
        
        <HeaderTasksInProgress />

        <HeaderNotifications />
  
        <!-- Menu do Usuário -->
        <el-dropdown>
          <span class="el-dropdown-link">
            <el-avatar v-if="user.avatar" size="32" src="/user-avatar.png"></el-avatar>
            <span class="username">{{ user.name  }}</span>
            <el-icon><arrow-down /></el-icon>
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <!-- <el-dropdown-item @click="navigateTo('/profile')">Meu Perfil</el-dropdown-item>               -->
              <el-dropdown-item divided @click="handleLogout">Sair</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
</el-header>
</template>

<script>
import { ElAvatar, ElDropdown, ElDropdownItem, ElDropdownMenu, ElHeader } from 'element-plus';
import { mapActions, mapGetters } from 'vuex';
import HeaderNotifications from './HeaderNotifications.vue';
import HeaderTasksInProgress from './HeaderTasksInProgress.vue';

export default {
  name: 'HeaderLayout',
  components: {    
    ElAvatar, ElDropdown, ElDropdownItem, ElDropdownMenu, ElHeader, HeaderNotifications, HeaderTasksInProgress
  },
  data() {
    return {
      isAdmin: false,
      user: {
        name: '',
        avatar: null,
      },
      activeMenu: '1', // Menu ativo (Home)      
      currentRoute: this.$route.path,
      inprogress: []
    };
  },
  watch: {
    $route(to) {
      this.currentRoute = to.path;
    }
  },
  computed: {
    ...mapGetters('auth', [
      'loggedUserName'
    ])
  },
  methods: {
    ...mapActions('taskData', ['openTaskModal']),

    handleLogout() {
      // Log out logic here
      console.log('Logged out');
      localStorage.removeItem('auth-token'); // Remover o token
      this.$router.push('/login'); // Redirecionar para login
    },

    navigateTo(route) {
      this.$router.push(route);
    },
    dataUserTop() {
      const user = JSON.parse(localStorage.getItem('loggedUser'));
      this.user.name = user.name;
      this.user.avatar = user.avatar;
    },
    handleCreateTask() {
      this.openTaskModal();
    },
    getIsAdmin() {
      const user = JSON.parse(localStorage.getItem('loggedUser'));
      
      this.isAdmin = user.isAdmin;
    },    
  },
  mounted() {    
    this.dataUserTop();
    this.getIsAdmin();    
  }
};
</script>
<style scoped>
/* Estilo global do layout */
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  background-color: #fff !important;
  border-bottom: 1px solid #e0e0e0;
}

.logo img {
  height: 40px;
}

.menu {
  flex: 1;
  margin-left: 20px;
}

.user-actions {
  display: flex;
  align-items: center;
  gap: 20px;
}

.username {
  margin: 0 10px;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  cursor: pointer;
}

@media screen and (max-width: 768px) { 


}
</style>
